import React from "react";
import CustomTag from "ui/components/Tags/CustomTag";
import { AcordoStatus } from "core/features/acordo/enums";
import { getStatusAcordoText } from "./../../../Detalhes/util/getStatusAcordoText";

interface TagStatusAcordoProps {
  status: AcordoStatus;
  dataCancelamento?: string;
  width?: string;
  px?: string;
}

function TagStatusAcordo({
  status,
  dataCancelamento,
  width = "200px",
  px,
}: TagStatusAcordoProps) {
  const colorMap: Record<AcordoStatus, string> = {
    [AcordoStatus.Cancelado]: "red.500",
    [AcordoStatus.EmAberto]: "blue.500",
    [AcordoStatus.Pago]: "green.500",
    [AcordoStatus.Renegociado]: "gray.500",
    [AcordoStatus.Encerrado]: "gray.500",
  };

  return (
    <CustomTag
      h="30px"
      borderColor={colorMap[status]}
      px={px}
      w={width}
      color={colorMap[status]}
    >
      {getStatusAcordoText(status, dataCancelamento)}
    </CustomTag>
  );
}

export default TagStatusAcordo;
